import React from "react";
import ReactGA from "react-ga4";
import { Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import EventTabs from "./components/EventTabs";
import NewEventDialog from "../../components/NewEventDialog/NewEventDialog"
import { EventContext } from "../../contexts/EventContext";
import request from "../../utilities/requests";

import "./styles.css";

const Events = ({ user }) => {
  const { setPairingEvents } = React.useContext(EventContext)
  const [addEventOpen, setAddEventOpen] = React.useState(false);

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/events",
      title: "Events",
    });
  }, []);

  const handleDialogClose = async () => {
    setAddEventOpen(false);
    const result = await request("pairingevent");
    if (result.success) {
      setPairingEvents(result.pairingEvents)
    }
  }

  return (
    <div>
      <EventTabs className="tab-header" user={user} />
      {/* {events.map((event) => {
          return <p key={event._id}>{event.name}</p>;
        })} */}
      <Fab
        color="primary"
        aria-label="add"
        style={{ position: "fixed", bottom: "5%", right: "5%" }}
        onClick={() => setAddEventOpen(true)}
      >
        <AddIcon />
      </Fab>
      <NewEventDialog
        open={addEventOpen}
        close={handleDialogClose}
      />
    </div>
  );
};

export default Events;
